import React, { useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { addCaseMilestone } from '../../../../services/case';

const { TextArea } = Input;
const { Option } = Select;

interface AddMilestoneModalProps {
  visible: boolean;
  caseId: number;
  onCancel: () => void;
  onSuccess: () => void;
}

const AddMilestoneModal: React.FC<AddMilestoneModalProps> = ({
  visible,
  caseId,
  onCancel,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // Handle form submit
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await addCaseMilestone(caseId, {
        milestone_type: values.milestone_type,
        description: values.description,
      });

      message.success('大事记添加成功');
      form.resetFields();
      onSuccess();
    } catch (error: any) {
      if (error.errorFields) {
        // Form validation error
        return;
      }
      console.error('Failed to add milestone:', error);
      message.error(error.message || '添加大事记失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  // Handle cancel
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  // Predefined milestone types
  const milestoneTypes = [
    '开庭',
    '判决',
    '调解',
    '和解',
    '撤诉',
    '上诉',
    '执行',
    '结案',
    '重要会议',
    '证据提交',
    '文书送达',
    '其他',
  ];

  return (
    <Modal
      title="添加大事记"
      open={visible}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        preserve={false}
      >
        <Form.Item
          name="milestone_type"
          label="事件类型"
          rules={[
            { required: true, message: '请选择或输入事件类型' },
            { max: 50, message: '事件类型不能超过50个字符' },
          ]}
        >
          <Select
            placeholder="请选择或输入事件类型"
            showSearch
            allowClear
            mode="tags"
            maxCount={1}
            style={{ width: '100%' }}
          >
            {milestoneTypes.map((type) => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="description"
          label="事件描述"
          rules={[
            { required: true, message: '请输入事件描述' },
            { max: 500, message: '事件描述不能超过500个字符' },
          ]}
        >
          <TextArea
            placeholder="请详细描述该事件的内容和相关信息"
            rows={6}
            showCount
            maxLength={500}
          />
        </Form.Item>

        <div style={{ color: '#8c8c8c', fontSize: 12, marginTop: -8 }}>
          提示：大事记用于记录案件过程中的重要事件和里程碑
        </div>
      </Form>
    </Modal>
  );
};

export default AddMilestoneModal;
